"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var MessagePublisher = /** @class */ (function () {
    function MessagePublisher(parentObject) {
        this.parentObject = parentObject;
    }
    MessagePublisher.getInstance = function (parentObject) {
        /* istanbul ignore else */
        if (!MessagePublisher.instance) {
            MessagePublisher.instance = new this(parentObject);
        }
        return MessagePublisher.instance;
    };
    MessagePublisher.prototype.sendMessage = function (message) {
        this.parentObject.postMessage(message, '*');
    };
    return MessagePublisher;
}());
exports.default = MessagePublisher;
//# sourceMappingURL=MessagePublisher.js.map